/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "3cc530ee7bc9f007173a7ca7a3ace53f2284c17a";
